import Repository from './repository';
import store from '../stores';
import { set as setUsers } from '../stores/users';
import { set as setDepartments } from '../stores/departments';
import { set as setDepartmentFilterOptions } from '../stores/department-filter';

/**
 * 管理画面のユーザー一覧を REST API から取得して Redux に反映する。
 */
export async function loadSystemManagerUsers(): Promise<void> {
  const repository = new Repository();
  const { data } = await repository.getUsers();
  store.dispatch(setUsers(data));
}

/**
 * 管理画面の部署一覧を REST API から取得して Redux に反映する。
 */
export async function loadSystemManagerDepartments(): Promise<void> {
  const repository = new Repository();
  const { data } = await repository.getDepartments();
  store.dispatch(setDepartments(data));
  store.dispatch(setDepartmentFilterOptions(data));
}

/**
 * 管理画面のユーザー・部署一覧を REST API から取得して Redux に反映する。
 * WebSocket の getInfo には依存しない。
 */
export async function loadSystemManagerLists(): Promise<void> {
  await Promise.all([loadSystemManagerUsers(), loadSystemManagerDepartments()]);
}
